import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Page1 from './components/Page1';
import Page2 from './components/Page2';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Root from './components/Root';
import ScrollToTop from './components/ScrollToTop';
import Thank from './components/Thank';
import Modall from './components/Modall';
import Calender from './components/CalenderPage';


const router = createBrowserRouter([
  {
    
    path: '/',
    element: <Root />,
    children: [
      { path: '/', element: <Page1 /> },
      { path: '/details', element: <Page2 /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '/terms', element: <Terms /> },
      { path: '/congrats', element: <Thank /> },
      { path: '/calender', element: <Calender />}
      
    ],
  },
]);

const App = () => {
  useEffect(() => {

    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.com/en_US/events.js');

    // Now safely call fbq() after the script is loaded
    window.fbq('init', '813473514289456');
    window.fbq('track', 'PageView');
  }, []);

  return (
    <RouterProvider router={router}>
      {/* Apply ScrollToTop globally */}
      {/* <ScrollToTop /> */}
      
    </RouterProvider>
  );
};

export default App;
